import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=6b371751&"
import script from "./Panel.vue?vue&type=script&lang=js&"
export * from "./Panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b371751')) {
      api.createRecord('6b371751', component.options)
    } else {
      api.reload('6b371751', component.options)
    }
    module.hot.accept("./Panel.vue?vue&type=template&id=6b371751&", function () {
      api.rerender('6b371751', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/panel/Panel.vue"
export default component.exports